import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
@Component({
  selector: 'atram-button',
  templateUrl: './atram-button.component.html',
  styleUrls: ['./atram-button.component.less']
})
export class AtramButtonComponent implements OnInit {

  @Input() buttonType: string = '';
  @Input() label: string = '';
  @Input() title: string = '';
  @Input() titlePosition: string = '';
  @Input() disabled: boolean = false;
  @Input() componentClass: string = '';
  @Input() icon: string = '';
  @Output('on-click') onClickEmitter: EventEmitter<any>;

  constructor() {
    this.onClickEmitter = new EventEmitter<void>();
  }

  ngOnInit() {
  }

  public onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.onClickEmitter.emit(event);
  }

}
